import { render } from "./incomePrint.vue?vue&type=template&id=2c24a78c&scoped=true"
import script from "./incomePrint.vue?vue&type=script&lang=js"
export * from "./incomePrint.vue?vue&type=script&lang=js"

import "./incomePrint.vue?vue&type=style&index=0&id=2c24a78c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2c24a78c"

export default script